// src/Component/former/Former.js
import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import './spiderless.css';
import spider12 from '../../image/spiderless12.png';

const Spiderless = () => {
  return (
    <div className="details-container">

      {/* SEO Meta Tags */}
      <Helmet>
        <title>Spiderless Cylinder Mould Manufacturers in India</title>
        <meta
          name="description"
          content="Spiderless Cylinder Mould Manufacturers in India. P. Rakesh Industries is a leading manufacturer of advanced spiderless cylinder moulds in India, offering high-speed, spiral wound, and inpro NEF cylinder moulds for paper machines. Our precision-engineered designs ensure excellent drainage, superior ply-bonding, and reliable performance for industrial applications."
        />
        <meta property="og:title" content="Spiderless Cylinder Mould Manufacturers in India" />
        <meta
          property="og:description"
          content="Spiderless Cylinder Mould Manufacturers in India. P. Rakesh Industries is a leading manufacturer of advanced spiderless cylinder moulds in India, offering high-speed, spiral wound, and inpro NEF cylinder moulds for paper machines. Our precision-engineered designs ensure excellent drainage, superior ply-bonding, and reliable performance for industrial applications."
        />
                <meta property="og:url" content="https://pripapermachines.com/spiderless-cylinder-mould-manufacturers-in-india" />
        <link rel="canonical" href="https://https://pripapermachines.com/spiderless-cylinder-mould-manufacturers-in-india" />
      </Helmet>

      <div className="details-content">
        {/* Left Column */}
        <div className="column left">
          <h1 style={{color:"#4d7544"}} className='mobileresponsiveview'>SPIDERLESS MOULD</h1>
          <div className="left-content">
            <img src={spider12} alt="Spiderless Cylinder Mould" />
          </div>
        </div>

        {/* Right Column */}
        <div className="column right">
          <div className="column-right">
            <h1 style={{color:"#4d7544", marginTop:"-10px",textAlign:"left",fontSize:"40px"}} className='desktopresponsiveview'>SPIDERLESS MOULD</h1>

            <div>
              <p
                style={{
                  backgroundColor: "#4d7544",
                  borderRadius: "10px",
                  color: "white",
                  paddingLeft: "20px",
                  paddingBottom: "20px",
                  paddingRight: "20px",
                  paddingTop: "20px",
                  width: "100%",
                  boxSizing: "border-box",
                  textAlign:"left"
                }}
              >
                <span className="dot"></span> The PRI spiderless cylinder mould enables a smoother rate of flow in the cylinder, improved cleaning, and more uniform board quality. Spiderless cylinders are designed for high-speed pressure formers, R.F. vats, or dry vats.
                <br /><br />
                <span className="dot"></span> PRI spiderless mould is spiral wound construction. It has been hand-welded throughout, with filler metal at every welding point. This ensures a cylinder mould that is sturdy, strong, and reliable. This mould is made with precise roundness and straightness. High accuracy of +/- 0.1 mm roundness is achieved.
                <br /><br />
                <span className="dot"></span> Cylinder moulds are normally manufactured with S.S. 304 or S.S. 316 construction, depending on the requirements of the customer. Due to its unique cage-type design, it can also be used as a Dandi roll, combi roll, etc. in fourdrinier system. Customised diameters can be manufactured to suit various applications.
              </p>

              <h1 style={{color:"#4d7544",textAlign:"left",fontSize:"26px",marginTop:"20px"}}>Key Features:</h1>
              <ul style={{color:"black",textAlign:"left",marginBottom:"60px"}}>
                <li>Excellent drainage</li><br />
                <li>It can be operated with a single cloth a single wire mesh.</li><br />
                <li>Better ply-bonding due to excellent drainage</li><br />
                <li>Better cleaning</li><br />
                <li>Lower operating costs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spiderless;
